module.exports = __webpack_public_path__ + "static/img/20-Media-City-Manchester-GettyImages-660700711.2e49dc88.jpg";